import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  Button,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ContactDetailsAPICall, stageDetailsAPICall } from "../shared/APICalls";
import { IAdminLogin, IMobile } from "../shared/dtos";
import routesData from "../shared/routes.json";
import SignupStyles from "../pages/Styles/SignUp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import BackDrop from "../Components/BackDrop";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import globeicon from "../Components/assets/Images/globeicon.svg";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";

export default function SignupPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathName = useLocation().pathname;
  const [prefillLoading, setprefillLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const [value, setValue] = useState();
  const [valuephone, setValuephone] = useState<any>();

  const [rejectMessage, setRejectMessage] = useState("");
  const [currentCountry, setCurrentCountry] = useState(
    getCountryCallingCode("IN")
  );
  const [defaultCountry, setDefaultCountry] = useState<any>("IN");
  const countryList = require("country-list");

  const navigationData = routesData;

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);

  //  console.log(Object.keys(params)[0]);

  const client_id = params.client_id;
  const user_id = params.user_id;

  if (source) {
    sessionStorage.setItem("source", source);
    sessionStorage.setItem("id", id);
  }

  const handlechange = (value: any) => {
    const phone = `+${currentCountry}${value.target.value}`;
    setValuephone(value.target.value);

    console.log("Is valid phone number:", isValidPhoneNumber(phone));
    console.log("formatPhoneNumberIntl", formatPhoneNumberIntl(phone));
  };
  const handleCountryChange = (data: any) => {
    console.log("handleCountryChange", data);
    if (data) {
      const countryCode = getCountryCallingCode(data);

      console.log("ISD Code:", countryCode);
      setCurrentCountry(countryCode);
    }
  };

  const handlechangeinput = () => {};

  function sendMobileNumber(data: any, country: any) {
    setloading(true);
    let obj: IMobile = {
      mobile: data,
      country_residency: country,
      country_code: `+${currentCountry}`,
    };
    ContactDetailsAPICall(obj)
      .then((response: any) => {
        sessionStorage.setItem("mobile", data);
        const responseData = response.data;

        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.error.message
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function validatePhoneNumber(value: any) {
    let error: any;
    if (!value) {
      error = "Mobile Number Required";
    }

    return error;
  }

  useEffect(() => {
    checkUserLoggedIn(navigate);
    let obj: any = {
      stage: "mobile",
    };
    setprefillLoading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        dispatch(setCompletedStages(response.data.data.completed_stages));
        dispatch(setCurrentStage(response.data.data.current_stage));
        const filteredCountry = countryList
          .getData()
          .filter(
            (a: any) => a.name === response.data?.data?.data?.country_residency
          );
        console.log("filteredCountry", response.data.data);
        if (response.data?.data?.data?.number) {
          setValuephone(response.data?.data?.data?.number);
        }
        if (response.data?.data?.data?.country_residency) {
          setValue(response.data?.data?.data?.country_residency);
        }
        if (response.data?.data?.data?.country_code) {
          setDefaultCountry(filteredCountry[0].code);
          setCurrentCountry(getCountryCallingCode(filteredCountry[0].code));
        }
        if (response.data?.data?.ErrorMessage) {
          setRejectMessage(response.data.data.ErrorMessage);
        }
        setprefillLoading(false);
      })
      .catch((error: any) => {
        setprefillLoading(false);
      });

    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        const onFormSubmit = (values) => {
          sendMobileNumber(values.phoneNumber, values.country);
        };

        event.preventDefault();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <>
      <ErrorSnackBar message={rejectMessage} />

      <div className={SignupStyles.wrapper}>
        <div className={SignupStyles.RightContainer}>
          <div className={SignupStyles.topLogoSection}>
            <img src={firstockLogo} className={SignupStyles.topLogo} />
          </div>
          <div className={SignupStyles.contentSection}>
            <div className={SignupStyles.headerSection}>
              <p className={SignupStyles.signup}>Contact Details</p>
            </div>

            {!prefillLoading ? (
              <Formik
                initialValues={{
                  country: value ? value : "",
                  phoneNumber: valuephone ? valuephone : "",
                }}
                onSubmit={(values) => {
                  sendMobileNumber(values.phoneNumber, values.country);
                }}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  values,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form
                    onKeyDown={(event) => {
                      event.code === "Enter" && handleSubmit();

                      // event.code.includes("Enter") && handleSubmit()
                    }}
                    style={{ width: "100%" }}
                  >
                    <div className={SignupStyles.feildsWrapper}>
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <Autocomplete
                          // size="small"

                          options={countryList
                            .getData()
                            ?.filter((list: any) => list.name !== "Pakistan")
                            .map((a: any) => a.name)}
                          value={values.country}
                          onChange={(event: any, newValue: any) => {
                            setFieldValue("country", newValue);
                            setValue(newValue);
                            const filteredCountry: any = countryList
                              .getData()
                              .filter((a: any) => a.name === newValue);
                            setDefaultCountry(filteredCountry[0].code);
                            console.log("newValue", filteredCountry);
                          }}
                          id="disable-clearable"
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select Country"}
                              placeholder="Select Country"
                              inputProps={{
                                ...params.inputProps,
                              }}
                              helperText={
                                touched.country && errors.country?.toString()
                              }
                              error={touched.country && Boolean(errors.country)}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <img
                                    src={globeicon}
                                    style={{ marginLeft: "8px" }}
                                  />
                                ),
                              }}
                            />
                          )}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          marginTop: "16px",
                          width: "100%",
                        }}
                      >
                        <PhoneInput
                          style={{ display: "none" }}
                          placeholder="Enter phone number"
                          defaultCountry={defaultCountry}
                          value={""}
                          onChange={handlechangeinput}
                          onCountryChange={handleCountryChange}
                        />

                        <Field
                          name="phoneNumber"
                          validate={validatePhoneNumber}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label=""
                              type="numeric"
                              placeholder="Enter Mobile Number"
                              className={SignupStyles.textfield}
                              variant="outlined"
                              value={values.phoneNumber}
                              helperText={
                                errors.phoneNumber &&
                                touched.phoneNumber && (
                                  <FormHelperText style={{ color: "#d32f2f" }}>
                                    {errors.phoneNumber.toString()}
                                  </FormHelperText>
                                )
                              }
                              onChange={(event: any) => {
                                setFieldValue(
                                  "phoneNumber",
                                  event.target.value
                                );
                                handlechange(event);
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              inputProps={{
                                sx: {
                                  "&::placeholder": {
                                    fill: "#111827",
                                    fontWeight: 400,
                                    fontStye: "normal",
                                  },
                                },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{ color: "#374151" }}
                                  >
                                    +{currentCountry}
                                  </InputAdornment>
                                ),
                              }}
                              onKeyPress={(event) => {
                                const keyCode = event.keyCode || event.which;
                                const keyValue = String.fromCharCode(keyCode);
                                const isValidKey = /^\d+$/.test(keyValue);

                                if (!isValidKey) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          )}
                        />
                      </div>

                      <SnackBar message={message} />

                      <div className={SignupStyles.buttonSection}>
                        {values.phoneNumber && values.country ? (
                          <LoadingButton
                            variant="contained"
                            type="submit"
                            loading={loading}
                            id="signupContinueButton"
                            className={SignupStyles.button}
                            onClick={() => {
                              handleSubmit();
                            }}
                          >
                            Continue
                          </LoadingButton>
                        ) : (
                          <Button
                            variant="contained"
                            disabled
                            className={SignupStyles.button}
                          >
                            Continue
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            ) : (
              <BackDrop />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
